export const breakPoints = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 428,
  tablet: 768,
  laptop: 1024,
  laptopL: 1439,
  desktop: 2560
}

export default {
  global: {
    fontNames: {
      serif: '"Playfair Display", serif',
      inter: '"Inter", sans-serif'
    },
    colors: {
      transparent: 'transparent',
      black: '#000000',
      white: '#ffffff',
      red: '#d44138',
      elemyGreen: '#004445',
      beige: '#f6efdb',
      darkGreen: '#113636',
      lightGreen: '#a3d29d',
      lightGray: '#f5f5f5',
      ironGray: '#74726b',
      halfSpanishWhite: '#e4dcc4',
      floralWhite: '#fffcf4',
      extBgBg2: '#fffcf5',
      genoa: '#2c786c',
      tiara: '#c9d4d4',
      blumine: '#2f6162',
      ecru: '#f5f2e8',
      easternBlue: '#195a5b',
      gainsboro: '#e2e2e2',
      sunglow: '#ffcf24',
      greenPea: '#1a635c',
      deepSeaGreen: '#094e4f',
      patina: '#5f8c8d',
      warmOrange: '#ede5d0',
      sweetAriel: '#e5eae3',
      kokoda: '#6c6859',
      cascade: '#99b2ae',
      bandicoot: '#817d70',
      fuscousGray: '#5c584a',
      shadowGreen: '#93bcbc',
      manhattan: '#f3b59c',
      armadillo: '#403e38',
      greenWhite: '#f2f3eb',
      napa: '#b0ac9e',
      aquaSqueeze: '#e5eCe5',
      eden: '#245c5c',
      blueStone: '#125c5e',
      tana: '#dedabf',
      tasman: '#d3e0d3',
      clayCreek: '#908860',
      silver: '#c4c4c4',
      paleSky: '#697386',
      athensGray: '#e4e8ed',
      mosque: '#02565a',
      heather: '#aeb5bd',
      divider: '#F0ECE0',

      // links
      textLinkGreen: '#568b8b',

      // dropDowns
      shadow: 'rgba(0, 0, 0, 0.07)',

      // inputs
      label: '#195a5b',
      whiteInputBorder: '#e4dcc4',
      whiteInputPlaceholder: '#bab9b5',
      whiteInputBg: '#ffffff',
      whiteInputText: '#195a5b',
      greenInputBorder: '#3c7878',
      greenInputPlaceholder: '#3c7878',
      greenInputBg: '#154242',
      greenInputText: '#ffffff',

      // buttons
      mainButtonBg: '#ffcf24',
      mainButtonBorder: '#ffcf24',
      mainButtonBgHover: '#ffb524',
      mainButtonBorderHover: '#ffb524',
      mainButtonText: '#004445',
      secondaryGreenTextButtonBorder: 'rgba(0, 68, 69, 0.4)',
      secondaryGreenTextButtonBorderHover: '#004445',
      secondaryGreenTextButtonBg: 'transparent',
      secondaryGreenTextButtonBgHover: 'rgba(0, 68, 69, 0.05)',
      secondaryGreenTextButtonText: '#2c786c',
      secondaryWhiteTextButtonBorder: 'rgba(255, 255, 255, 0.5)',
      secondaryWhiteTextButtonBorderHover: '#ffffff',
      secondaryWhiteTextButtonBg: 'transparent',
      secondaryWhiteTextButtonBgHover: '#1a635c',
      secondaryWhiteTextButtonText: '#ffffff',
      smallButtonBorder: 'rgba(0, 68, 69, 0.4)',
      smallButtonBorderHover: '#004445',
      smallButtonBg: 'transparent',
      smallButtonBgHover: 'rgba(0, 68, 69, 0.05)',
      smallButtonText: '#2c786c'
    },
    depth: {
      negative: '-1',
      zero: '0',
      normal: '1',
      elevated: '10',
      overlay: '100'
    },
    font: {
      heading: {
        small: {
          size: '2.4rem' // 24px
        },
        compact: {
          size: '2.8rem' // 28px
        },
        normal: {
          size: '3.2rem' // 32px
        },
        large: {
          size: '3.6rem' // 36px
        },
        xlarge: {
          size: '4rem' // 40px
        },
        xxlarge: {
          size: '4.6rem' // 46px
        }
      },
      context: {
        small: {
          size: '1.2rem' // 12px
        },
        compact: {
          size: '1.4rem' // 14px
        },
        normal: {
          size: '1.6rem' // 16px
        },
        large: {
          size: '1.8rem' // 18px
        }
      },
      weight: {
        normal: 400,
        medium: 500,
        semiBold: 600,
        bold: 700
      }
    }
  },
  text: {
    xxxsmall: {
      size: '1rem',
      height: '1'
    },
    xxsmall: {
      size: '1.1rem',
      height: '1'
    },
    xsmall: {
      size: '1.2rem', // 12px
      height: '1.2'
    },
    small: {
      size: '1.3rem', // 13px
      height: '1.538' // ~20px
    },
    compact: {
      size: '1.4rem', // 14px
      height: '1.42' // ~20px
    },
    normal: {
      size: '1.6rem', // 16px
      height: '1.625' // 24px
    },
    large: {
      size: '1.6rem', // 16px
      height: '1.5' // 24px
    },
    xlarge: {
      size: '1.8rem', // 18px
      height: '1.32' // ~24px
    }
  },

  // Example of usage:
  // @media ${device.mobileS} {
  //   font-size: 2rem;
  // }
  container: {
    small: '117.1rem',
    normal: '168rem'
  },
  device: {
    mobileS: `(max-width: ${breakPoints.mobileS}px)`,
    mobileM: `(max-width: ${breakPoints.mobileM}px)`,
    mobileL: `(max-width: ${breakPoints.mobileL}px)`,
    tablet: `(max-width: ${breakPoints.tablet}px)`,
    laptop: `(max-width: ${breakPoints.laptop}px)`,
    laptopL: `(max-width: ${breakPoints.laptopL}px)`,
    desktop: `(max-width: ${breakPoints.desktop}px)`
  }
}
